// extracted by css-extract-rspack-plugin
export default {"ColorDecoratorMain":"ColorDecorator-module__ColorDecoratorMain__KzjEbqH"};